var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SiteHeader'),_c('Navigation'),_c('main',{staticClass:"header-space transition-ease-out vh-100",class:{ 'nav-space': _vm.isNavMenuOpen }},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }